module.exports = __webpack_public_path__ + "static/img/close.12d8c859.png";